module.exports = __webpack_public_path__ + "img/1.748ccdc8.png";